import { Controller } from "@hotwired/stimulus"

// This controller sets the is-active class on the leads list links whenever the HTML changes. This allows us
// to update the links using Turbo Streams.
export default class extends Controller {
  static get values() {
    return { id: Number }
  }

  static get targets() {
    return ["link"]
  }

  linkTargetConnected() {
    this.linkTargets.forEach((link) => {
      if (parseInt(link.dataset.id) === this.idValue) {
        link.classList.add("is-active")
      } else {
        link.classList.remove("is-active")
      }
    })
  }
}
